export const decodePathValue = (value?: string): string | undefined => {
    if (!value) return value;
    return value
        .replace(/\+/g, ' ')
        .replace(/(^\w{1})|(\s+\w{1})/g, (letter) => letter.toUpperCase());
};
